import cx from 'clsx';
import { ArrowRightIcon } from '@heroicons/react/solid';
import { Icon } from '@vechaiui/react';
import { useLocalization } from '@fluent/react';
import { useNavigate } from 'react-router-dom';

import moveLogoUrl from '#/assets/static-page/move_logo_nav_bar.svg';
import { PublicRoute } from '#/constants/page-route';

const NavigationalBar: React.FC<NavigationalBarProps> = ({ isBgTransparent }) => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  return (
    <div
      className={cx(
        'flex min-w-full h-[100px] px-24 justify-between items-center text-black border-b border-neutral-300',
        !!isBgTransparent && isBgTransparent ? 'bg-transparent' : 'bg-white',
      )}
    >
      <div className="fill-blue-700">
        <img
          src={moveLogoUrl}
          className="w-28 hover:cursor-pointer"
          onClick={() => navigate(PublicRoute.Home)}
        />
      </div>
      <div className="flex items-center space-x-10">
        <div className="hover:cursor-pointer" onClick={() => navigate(PublicRoute.AboutUs)}>
          {l10n.getString('about')}
        </div>
        {/* <div className="hover:cursor-pointer" onClick={() => navigate(PublicRoute.Faq)}>
          {l10n.getString('help')}
        </div> */}
        <div className="hover:cursor-pointer" onClick={() => navigate(PublicRoute.Login)}>
          <button className="flex items-center justify-between w-40 px-5 py-4 bg-blue-700 rounded-full hover:cursor-pointer">
            <div className="text-white">{l10n.getString('login')}</div>
            <Icon as={ArrowRightIcon} className="w-5 text-white" label="selector" />
          </button>
        </div>
      </div>
    </div>
  );
};

type NavigationalBarProps = {
  isBgTransparent?: boolean;
};

export default NavigationalBar;
